import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService, TransportMode } from '@hazmatsuite-next/ui';
import { map } from 'rxjs';
import { EasyDgdDataState } from '../../store/easydgd-data.reducer';
import { Store } from '@ngrx/store';
import { setTransportMode } from '../../store/easydgd-data.actions';

@Component({
  selector: 'easydgd-transportmode',
  templateUrl: './transportmode.component.html',
  styleUrls: ['./transportmode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransportmodeComponent {
  public transportModes = TransportMode;
  public showConfirmationModal = false;

  public layoutResource$ = this.languageService.translations$.pipe(
    map(translations => translations['LayoutResource']));
  public transportModeResource$ = this.languageService.translations$.pipe(
    map(translations => translations['EasyDgdTransportModeResource']));

  constructor(
    private store: Store<{ easyDgdState: EasyDgdDataState }>,
    private route: ActivatedRoute,
    private router: Router,
    private languageService: LanguageService) {
  }

  selectTransportMode(transportMode: TransportMode): void {
    if (transportMode === TransportMode.Air) {
      this.showConfirmationModal = true;
    } else {
      this.setTransportMode(transportMode);
    }
  }

  setTransportMode(transportMode: TransportMode): void {
    this.store.dispatch(setTransportMode({ transportMode }));
  }
}
